<template>
  <div>
    <LiteUserProfile @getUserDetails="setUserDetails"></LiteUserProfile>
    <template v-if="userDetails">
      <UserBoughtLessonList
        :userFullName="userDetails.fullName"
        :userIdFilter="$route.params.id"
      ></UserBoughtLessonList>
      <StudentScheduleHistory
        :userIdFilter="$route.params.id"
        :userFullName="userDetails.fullName"
        :priceCategoryId="priceCategoryId"
      ></StudentScheduleHistory>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      userDetails: null,
    };
  },
  methods: {
    setUserDetails(userDetails) {
      this.userDetails = userDetails;
    },
  },
  computed: {
    priceCategoryId() {
      if (this.$route.params && this.$route.params.priceCategoryId) {
        return this.$route.params.priceCategoryId;
      }
      return null;
    },
  },
  components: {
    UserBoughtLessonList,
    StudentScheduleHistory,
    LiteUserProfile,
  },
};
import UserBoughtLessonList from "@/views/components/UserBoughtLessons/UserBoughtLessonList.vue";
import StudentScheduleHistory from "@/views/apps/MasterSchedule/StudentScheduleHistory.vue";
import LiteUserProfile from "@/views/components/Users/LiteUserProfile.vue";
</script>
